export const beritaData = [
  {
    id: 1,
    image: "/images/asset/gambar-1.svg",
    title:
      "Sosialisasi Masa Persiapan Pensiun kepada Karyawan PT. Toyota Astra Motor",
    summary:
      "Sosialisasi Masa Persiapan Pensiun kepada karyawan PT. Toyota Astra Motor Para Pengurus Dapen Toyota Astra hadir dalam acara sosialisasi persiapan memasuki manfaat...",
    date: "8 Agustus 2024",
    content: `Sosialisasi Masa Persiapan Pensiun kepada karyawan PT. Toyota Astra Motor Para Pengurus Dapen Toyota Astra hadir dalam acara sosialisasi persiapan memasuki manfaat pensiun kepada karyawan PT. TAM yang akan memasuki masa pensiun. Acara diadakan di Bogor, Jawa Barat pada tanggal 8 Agustus'24.`,
    galeri: [
      "/images/asset/galeri3.svg",
      "/images/asset/galeri1.svg",
      "/images/asset/galeri2.svg",
    ],
    link: "/berita/1",
  },
  {
    id: 2,
    image: "/images/asset/gambar-2.svg",
    title: "(FGD) Mengupas Tuntas POJK 27/2023...",
    summary:
      "Menghadiri diskusi dan tanya jawab Dana Pensiun bersama dengan pihak otoritas peraturan perbankan dan para pengurus Dana Pensiun secara proaktif menghadapi...",
    date: "22 Juli 2024",
    content: `Menghadapi dinamika dalam dunia Dana Pensiun, termasuk dengan adanya peraturan-peraturan baru, para pengurus Dana Pensiun secara proaktif mengadakan diskusi dengan para pihak terkait. Dalam foto pertama, Pengurus Dana Pensiun bersama dengan HRD PT. TMMIN berdiskusi dengan para mitra, yaitu DPLK Tokyo Marine Life Insurance. Hadir juga dalam acara diskusi tersebut Bapak Bob Azam, Wakil Presiden Direktur PT. TMMIN, ibu Marianty Indira, Executive Board dari DPLK Tokyo Marine Life Indonesia dan bapak Nur Hasan sebagai expert masalah Dana Pensiun.`,
    galeri: [
      "/images/asset/galeri3.svg",
      "/images/asset/galeri1.svg",
      "/images/asset/galeri2.svg",
    ],
    link: "/berita/2",
  },
  {
    id: 3,
    image: "/images/asset/gambar-3.svg",
    title: "Sosialisasi Dana Pensiun Kepada Karyawan...",
    summary:
      "Para Pengurus Dana Pensiun mengadakan sosialisasi Dana Pensiun kepada para pegawai SPSI, di Auditorium Plant Sunter II...",
    date: "14 Juni 2024",
    content: `Sosialisasi Dana Pensiun Kepada Karyawan SPSI.

Para pengurus Dana Pensiun menyampaikan informasi penting mengenai manfaat, mekanisme pencairan, serta hak dan kewajiban peserta pensiun. 

Kegiatan ini berlangsung di Auditorium Plant Sunter II dan diikuti secara antusias oleh para peserta.`,
    galeri: [
      "/images/asset/galeri3.svg",
      "/images/asset/galeri1.svg",
      "/images/asset/galeri2.svg",
    ],
    link: "/berita/3",
  },
];
